import { CgOptions } from "react-icons/cg";
import { FaBell, FaDesktop, FaLock, FaMobile, FaSafari, FaSync } from "react-icons/fa";


export function SafariInstructions({ isMobile }: { isMobile: boolean }) {
  const instructions =
    isMobile
      ? [
        { icon: <FaMobile />, text: "פתח את הגדרות המכשיר" },
        { icon: <FaSafari />, text: 'גלול מטה ובחר ב"Safari"' },
        { icon: <FaLock />, text: 'הקש על "הגדרות אתר"' },
        { icon: <FaBell />, text: 'בחר ב"התראות"' },
        { icon: <FaSync />, text: "מצא את האתר שלנו ברשימה והפעל את ההתראות" },
      ]
      : [
        { icon: <FaDesktop />, text: 'לחץ על Safari בתפריט העליון ובחר ב"העדפות"' },
        { icon: <CgOptions />, text: 'עבור ללשונית "אתרים"' },
        { icon: <FaBell />, text: 'בחר ב"התראות" בצד שמאל' },
        { icon: <FaSync />, text: 'מצא את האתר שלנו ברשימה ושנה את ההגדרה ל"אפשר"' },
        { icon: <FaSync />, text: "רענן את הדף" },
      ]

  return (
    <ol className="space-y-4">
      { instructions.map((instruction, index) => (
        <li key={ index } className="flex items-center space-x-4 rtl:space-x-reverse">
          <span className="flex-shrink-0 w-8 h-8 flex items-center justify-center bg-purple-600 rounded-full text-white">
            { instruction.icon }
          </span>
          <span className="text-gray-200">{ instruction.text }.</span>
        </li>
      )) }
    </ol>
  )
}


//
